import React from 'react'
import Profile from '../../Reuseable/Profile'
import noImage from '../../../assets/images/settings/no-image.png';
const AuditionProfile = () => {
  return (
    <>
          <Profile 
              name={"Shakib Al Hasan"}
              coverImg={noImage}
              profileImg={noImage}
              userName={"@shakib75"}
              termsConditions={"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled."}
               mail={"shakib75@gmail.com"}
               phone={"+880 1732-95XXX"}
               
          />
    </>
  )
}

export default AuditionProfile
